export const deals = [
  {
    id: "1",
    dealNo: " 1",
    description: "1 Large Pizza, 1 Medium Pizza, 1 Small Pizza and 1.5L Drink",
    price: "3000",
  },
  {
    id: "2",
    dealNo: " 2",
    description: "2 Large Pizza, Large Salad,Family Fries and 2 1.5L Drinks",
    price: "3700",
  },
  {
    id: "3",
    dealNo: " 3",
    description: "2 Medium Pizza, Large Salad, Large Fries and 1.5L Drink",
    price: "2600",
  },
  {
    id: "4",
    dealNo: " 4",
    description: "1 Large Pizza, 1 Medium Salad and 1.5L Drink",
    price: "1750",
  },
  {
    id: "5",
    dealNo: " 5",
    description:
      "1 Medium Pizza, 1 Zinger burger, Hot Wings[12pcs] and 1.5L Drink",
    price: "2000",
  },
  {
    id: "6",
    dealNo: " 6",
    description: "5 Zinger Burgers and 1.5L Drink",
    price: "1850",
  },
  {
    id: "7",
    dealNo: "7",
    description: "2 Zinger Burgers and 500ml Drink [Dine In Only]",
    price: "720",
  },
  {
    id: "8",
    dealNo: " 8",
    description: "Small Pizza, Regular Pizza, Regular Drink",
    price: "720",
  },
];
